import { authSplitApi } from 'redux/helpers/slice.helpers';
import { TAuthUserUi, TAuthUser } from 'data/types';
import { userConverter } from 'data/converters/user.converters';

const GET_AUTH_USER = 'api/users';

export const getUserApi = authSplitApi('authUser', ['User']).injectEndpoints({
  endpoints: build => ({
    getUser: build.query<TAuthUserUi, any>({
      query() {
        return {
          url: GET_AUTH_USER,
          method: 'GET',
        };
      },
      providesTags: ['User'],
      keepUnusedDataFor: 60 * 60 * 24,
      transformResponse: (data: TAuthUser) => userConverter.fromDb(data),
    }),
    changeTheme: build.mutation<void, { resourceId: string; theme: string }>({
      query({ resourceId, theme }) {
        return {
          headers: {
            'content-type': 'application/json',
          },
          url: GET_AUTH_USER.concat(`/${resourceId}/theme`),
          method: 'PATCH',
          body: { value: theme },
        };
      },
    }),
    getUserTimezone: build.query<string, { resourceId: string }>({
      query({ resourceId }) {
        return {
          url: GET_AUTH_USER.concat(`/${resourceId}/timezone`),
          method: 'GET',
        };
      },
      transformResponse: (data: { value: string }) => data.value,
    }),
    changeUserTimezone: build.mutation<
      void,
      { resourceId: string; timeZone: string }
    >({
      query({ resourceId, timeZone }) {
        return {
          headers: {
            'content-type': 'application/json',
          },
          url: GET_AUTH_USER.concat(`/${resourceId}/timezone`),
          method: 'PATCH',
          body: { value: timeZone },
        };
      },
      invalidatesTags: ['User'],
    }),
    saveTableSettings: build.mutation<
      void,
      { resourceId: string; tableSettingsJson: string }
    >({
      query({ resourceId, tableSettingsJson }) {
        return {
          headers: {
            'content-type': 'application/json',
          },
          url: GET_AUTH_USER.concat(`/${resourceId}/table-settings`),
          method: 'PATCH',
          body: { value: tableSettingsJson },
        };
      },
      async onQueryStarted(
        { tableSettingsJson },
        { dispatch, queryFulfilled },
      ) {
        const patchResult = dispatch(
          getUserApi.util.updateQueryData('getUser', {}, draft => {
            draft.tableSettingsJson = tableSettingsJson;
          }),
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserQuery,
  useChangeThemeMutation,
  useGetUserTimezoneQuery,
  useChangeUserTimezoneMutation,
  useSaveTableSettingsMutation,
} = getUserApi;
